import React from "react";
import { Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  interval: {
    marginTop: theme.spacing(5),
  },
}));

export default function Start(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Alert variant="outlined" severity="info">
        このページではシステムを使って出品できるまでの流れを説明しています。
      </Alert>

      <div className={classes.interval}>
        <Typography variant="h4" align="center" gutterBottom>
          はじめに
        </Typography>
        <iframe
          title="Manual"
          src="https://hp.pluselect.com/start"
          width="100%"
          height="800"
        />
      </div>
    </React.Fragment>
  );
}
